// const rootRoute = `${window.location.origin}/api/`
// const rootRoute = "http://localhost:9000/api/"
const rootRoute = "https://app.taqwahqm.com/api/"

export const login = rootRoute + "user/login";
export const updateUserGeneralSetting = rootRoute + "user/updateUserGeneralSetting";
export const userPasswordChange = rootRoute + "user/userPasswordChange";
export const userLogOutFromAllDevice = rootRoute + "user/userLogOutFromAllDevice";
export const getAllUser = rootRoute + "user/getAllUser";
export const getAllRole = rootRoute + "user/getAllRole";
export const addUser = rootRoute + "user/addUser";
export const updateUserFromAdmin = rootRoute + "user/updateUserFromAdmin";
export const resetUserPasswordFromAdmin = rootRoute + "user/resetUserPasswordFromAdmin";

export const getAllAgent = rootRoute + "user/getAllAgent";
export const getAllAgentForDropDown = rootRoute + "user/getAllAgentForDropDown";
export const FindAgentByMobile = rootRoute + "user/FindAgentByMobile";
export const addAgent = rootRoute + "user/addAgent";
export const updateAgent = rootRoute + "user/updateAgent";
export const agentBalancePayment = rootRoute + "user/agentBalancePayment";
export const resetAgentPasswordFromAdmin = rootRoute + "user/resetAgentPasswordFromAdmin";
export const importNewAgent = rootRoute + "user/importNewAgent";
export const getAgentWalletHistory = rootRoute + "user/getAgentWalletHistory";
export const getAgentCollectionHistory = rootRoute + "user/getAgentCollectionHistory";

export const getAgentPromisedHistory = rootRoute + "user/getAgentPromisedHistory";



export const getTotalDue = rootRoute + "member/getTotalDue";

export const getAllMember = rootRoute + "member/getAllMember";
export const getAllMemberAtonce = rootRoute + "member/getAllMemberAtonce";
export const addMember = rootRoute + "member/addMember";
export const updateMember = rootRoute + "member/updateMember";
export const donationCollection = rootRoute + "member/donationCollection";
export const getAgentWiseMember = rootRoute + "member/getAgentWiseMember";
export const getAllMembersForExport = rootRoute + "member/getAllMembersForExport";
export const importMember = rootRoute + "member/importMember";
export const findMemberByMobile = rootRoute + "member/findMemberByMobile";

export const memberLogin = rootRoute + "member-auth/login";
export const getAllOrganization = rootRoute + "organization/get-all-organization";
export const promisedToCollection = rootRoute + "member/promisedToCollection";
export const removePromise = rootRoute + "member/removePromise";
export const updatePromisedAmount = rootRoute + "member/updatePromisedAmount";
export const getAllCollectionAmount = rootRoute + "user/getAllCollectionAmount";
export const getAllPromisedCollectionAmount = rootRoute + "user/getAllPromisedCollectionAmount";
export const getAgentSingleCollectionHistory = rootRoute + "user/getAgentSingleCollectionHistory";
export const getAgentSinglePromisedHistory = rootRoute + "user/getAgentSinglePromisedHistory";







